var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 85,
    viewBox: "0 0 80 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 84.3096C62.09 84.3096 80 66.3996 80 44.3096C80 22.2196 62.09 4.30957 40 4.30957C17.91 4.30957 0 22.2196 0 44.3096C0 66.3996 17.91 84.3096 40 84.3096Z",
    fill: "#E0E9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3397 30.4396C69.3397 29.9096 68.7097 28.8696 68.6897 27.7396C68.7097 26.9896 68.1097 26.3696 67.3597 26.3496H62.0397C61.2897 26.3696 60.6897 26.9896 60.7097 27.7396C60.6897 28.8696 60.0597 29.9096 59.0597 30.4396C55.1597 32.5196 52.7197 36.5796 52.7197 40.9996V42.7196H56.7097V52.3196C56.7097 53.2496 56.9397 54.1596 57.3797 54.9796V57.6396H72.0297V54.9696C72.4597 54.1496 72.6897 53.2296 72.6997 52.3096V48.6896C74.9097 48.6896 76.6897 46.8996 76.6897 44.6996V40.9996C76.6897 36.5796 74.2497 32.5196 70.3497 30.4396H70.3397Z",
    fill: "#2B6BF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6897 80.6704C69.7997 80.6704 73.9497 79.8904 73.9497 78.9304C73.9497 77.9704 69.7997 77.1904 64.6897 77.1904C59.5797 77.1904 55.4297 77.9704 55.4297 78.9304C55.4297 79.8904 59.5797 80.6704 64.6897 80.6704Z",
    fill: "#2B6BF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3701 57.6396L60.0301 78.2796H69.3501L72.0101 57.6396H57.3701Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3701 57.6396L60.0301 78.2796H69.3501L72.0101 57.6396H57.3701Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6497 78.2703C72.3797 78.2703 72.9797 77.6903 72.9897 76.9603C72.9897 76.7503 72.9397 76.5303 72.8397 76.3403C72.1397 75.0703 70.7997 74.2803 69.3397 74.2803H68.6697C66.4597 74.2803 64.6797 76.0703 64.6797 78.2703H71.6497Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6898 78.2703C64.6898 76.0603 62.8998 74.2803 60.6998 74.2803H60.0298C58.5698 74.2803 57.2298 75.0703 56.5298 76.3403C56.1998 76.9903 56.4498 77.7903 57.1098 78.1303C57.2998 78.2303 57.5198 78.2803 57.7298 78.2803H64.6898V78.2703Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6904 57.6396V78.2696",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3397 30.4396C69.3397 29.9096 68.7097 28.8696 68.6897 27.7396C68.7097 26.9896 68.1097 26.3696 67.3597 26.3496H62.0397C61.2897 26.3696 60.6897 26.9896 60.7097 27.7396C60.6897 28.8696 60.0597 29.9096 59.0597 30.4396C55.1597 32.5196 52.7197 36.5796 52.7197 40.9996V42.7196H56.7097V52.3196C56.7097 53.2496 56.9397 54.1596 57.3797 54.9796V57.6396H72.0297V54.9696C72.4597 54.1496 72.6897 53.2296 72.6997 52.3096V48.6896C74.9097 48.6896 76.6897 46.8996 76.6897 44.6996V40.9996C76.6897 36.5796 74.2497 32.5196 70.3497 30.4396H70.3397Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0101 54.9805H57.3701",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7002 51.6501V40.3301",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.68 48.6901H66.29V43.6501H69.74C70.83 43.6501 71.71 42.7701 71.71 41.6801V40.3301",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 18.4696C73.75 17.6896 73.19 17.0196 72.42 16.8696V15.7996C72.42 11.3896 68.84 7.80957 64.43 7.80957C60.02 7.80957 56.44 11.3896 56.44 15.7996V16.8696C55.55 17.0296 54.97 17.8796 55.13 18.7696C55.26 19.4996 55.87 20.0396 56.6 20.0996C57.5 24.4196 61.73 27.1896 66.05 26.2896C69.16 25.6396 71.59 23.2096 72.24 20.0996C73.08 20.0196 73.73 19.3196 73.74 18.4696H73.75Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1104 21.1299C60.6604 21.1299 61.1104 20.6799 61.1104 20.1299C61.1104 19.5799 60.6604 19.1299 60.1104 19.1299C59.5604 19.1299 59.1104 19.5799 59.1104 20.1299C59.1104 20.6799 59.5604 21.1299 60.1104 21.1299Z",
    fill: "#2B6BF3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7598 21.1299C69.3098 21.1299 69.7598 20.6799 69.7598 20.1299C69.7598 19.5799 69.3098 19.1299 68.7598 19.1299C68.2098 19.1299 67.7598 19.5799 67.7598 20.1299C67.7598 20.6799 68.2098 21.1299 68.7598 21.1299Z",
    fill: "#2B6BF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0297 17.7997C67.5897 17.3597 66.8697 17.3597 66.4297 17.7997",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8301 17.7997C61.2701 17.3597 61.9901 17.3597 62.4301 17.7997",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4304 22.46C65.2504 23.35 63.6204 23.35 62.4404 22.46",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.15 3.67969L67.96 5.30969",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4295 11.4899C66.9995 11.4899 69.0895 9.39992 69.0895 6.82992C69.0895 4.25992 66.9995 2.16992 64.4295 2.16992C61.8595 2.16992 59.7695 4.25992 59.7695 6.82992C59.7695 9.39992 61.8595 11.4899 64.4295 11.4899Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7598 5.81957C57.8698 5.81957 55.6298 10.5096 55.1898 14.3496C55.1198 15.0796 55.6498 15.7196 56.3798 15.7896C56.4298 15.7896 56.4698 15.7896 56.5198 15.7896H72.3298C73.0598 15.7896 73.6598 15.2096 73.6698 14.4796C73.6698 14.4296 73.6698 14.3896 73.6698 14.3396C73.2298 10.4896 70.9898 5.80957 65.0998 5.80957H63.7698L63.7598 5.81957Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1104 15.7997V12.4697",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4297 15.7997V12.4697",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4297 15.7997V12.4697",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7598 15.7997V12.4697",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7598 5.81957C57.8698 5.81957 55.6298 10.5096 55.1898 14.3496C55.1198 15.0796 55.6498 15.7196 56.3798 15.7896C56.4298 15.7896 56.4698 15.7896 56.5198 15.7896H72.3298C73.0598 15.7896 73.6598 15.2096 73.6698 14.4796C73.6698 14.4296 73.6698 14.3896 73.6698 14.3396C73.2298 10.4896 70.9898 5.80957 65.0998 5.80957H63.7698L63.7598 5.81957Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7299 2.77965C73.5699 3.86965 72.5599 4.62965 71.4699 4.47965C70.3799 4.32965 69.6199 3.30965 69.7699 2.21965C69.7699 2.21965 69.7699 2.21965 69.7699 2.20965C69.9299 1.11965 70.9499 0.359645 72.0399 0.529645C73.1299 0.689645 73.8799 1.69965 73.7199 2.78965L73.7299 2.77965Z",
    fill: "#2B6BF3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7299 2.77965C73.5699 3.86965 72.5599 4.62965 71.4699 4.47965C70.3799 4.32965 69.6199 3.30965 69.7699 2.21965C69.7699 2.21965 69.7699 2.21965 69.7699 2.20965C69.9299 1.11965 70.9499 0.359645 72.0399 0.529645C73.1299 0.689645 73.8799 1.69965 73.7199 2.78965L73.7299 2.77965Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6495 49.3404L44.9995 53.3504C44.5595 53.4504 44.1195 53.1704 44.0095 52.7304L39.2695 31.8804L42.3695 26.9604L56.8095 23.6804C57.2495 23.5804 57.6895 23.8604 57.7895 24.3004L63.2595 48.3704C63.3595 48.8104 63.0795 49.2504 62.6395 49.3504L62.6495 49.3404Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6495 49.3404L44.9995 53.3504C44.5595 53.4504 44.1195 53.1704 44.0095 52.7304L39.2695 31.8804L42.3695 26.9604L56.8095 23.6804C57.2495 23.5804 57.6895 23.8604 57.7895 24.3004L63.2595 48.3704C63.3595 48.8104 63.0795 49.2504 62.6395 49.3604L62.6495 49.3404Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2803 31.88L42.4903 31.15C42.9303 31.05 43.2103 30.61 43.1103 30.17L42.3803 26.96L39.2803 31.88Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2998 30.0505L55.3198 28.2305",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2197 34.3604L56.0497 31.4404",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9502 37.5597L56.7802 34.6396",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6699 40.7696L57.4999 37.8496",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4004 43.9796L58.2304 41.0596",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1299 47.1895L58.9599 44.2695",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2897 43.96H64.0097C62.7197 43.96 61.6797 45 61.6797 46.29C61.6797 47.58 62.7197 48.62 64.0097 48.62H66.2897V43.96Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0702 80.77C28.4602 80.77 33.6502 79.99 33.6502 79.03C33.6502 78.07 28.4702 77.29 22.0702 77.29C15.6702 77.29 10.4902 78.07 10.4902 79.03C10.4902 79.99 15.6702 80.77 22.0702 80.77Z",
    fill: "#2B6BF3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7303 52.7004C25.2603 52.7004 24.0703 51.5104 24.0703 50.0404V35.0804C24.0703 34.8504 24.1303 34.6304 24.2403 34.4304L26.5903 30.1904C31.8703 32.0904 35.3903 37.1004 35.3903 42.7204V45.0804C35.3903 46.3604 36.4203 47.4004 37.7003 47.4004H38.7003V52.7004H36.5103C33.3103 52.7004 30.7203 50.1104 30.7203 46.9104V52.7004H26.7303Z",
    fill: "#2B6BF3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0803 76.2899V72.3799C14.3203 72.5699 14.6103 72.6699 14.9103 72.6699H19.4003V76.2199C19.4003 76.2199 14.0803 76.2899 14.0703 76.2899H14.0803Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2804 78.6599C12.5504 78.6599 11.9504 78.0799 11.9404 77.3499C11.9404 77.1299 11.9904 76.9199 12.0904 76.7299C12.7904 75.4599 14.1404 74.6699 15.5904 74.6699H16.2604C17.7204 74.6699 19.0604 75.4599 19.7604 76.7299C20.0904 77.3799 19.8404 78.1799 19.1804 78.5099C18.9904 78.6099 18.7804 78.6599 18.5604 78.6599H13.2804Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 55.3604L13.5899 71.3403C13.5899 72.0703 14.1899 72.6703 14.9199 72.6703H19.5799L19.9399 62.0904C19.9399 60.9104 20.8999 59.9504 22.0799 59.9504C23.2599 59.9504 24.2199 60.9104 24.2199 62.0904L24.5799 72.6703H29.2399C29.9799 72.6703 30.5699 72.0703 30.5699 71.3403L30.7399 55.3604H13.4299H13.4199Z",
    fill: "#2B6BF3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 55.3604L13.5899 71.3403C13.5899 72.0703 14.1899 72.6703 14.9199 72.6703H19.5799L19.9399 62.0904C19.9399 60.9104 20.8999 59.9504 22.0799 59.9504C23.2599 59.9504 24.2199 60.9104 24.2199 62.0904L24.5799 72.6703H29.2399C29.9799 72.6703 30.5699 72.0703 30.5699 71.3403L30.7399 55.3604H13.4299H13.4199Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7299 50.1998C25.2599 50.1998 24.0699 49.0098 24.0699 47.5398V35.0798C24.0699 34.8498 24.1299 34.6298 24.2399 34.4298L26.5899 30.1898C23.6699 29.1398 20.4699 29.1398 17.5499 30.1898L19.8999 34.4298C20.0099 34.6298 20.0699 34.8498 20.0699 35.0798V47.5498C20.0699 49.0198 18.8799 50.2098 17.4099 50.2098H13.4199V55.3698H30.7299V50.2098H26.7399L26.7299 50.1998Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5298 29.8596C25.1098 29.7496 24.8098 29.3696 24.8198 28.9396V23.8496H19.3498V28.9296C19.3498 29.3596 19.0598 29.7396 18.6298 29.8496C18.2598 29.9496 17.8998 30.0496 17.5498 30.1796C19.1698 33.0896 19.4998 34.0496 22.0698 34.0496C24.6398 34.0496 24.9698 33.0896 26.5898 30.1796C26.2398 30.0596 25.8898 29.9496 25.5298 29.8596Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0602 76.2199V72.3799C29.8202 72.5699 29.5302 72.6699 29.2302 72.6699H24.7402V76.2199H30.0702H30.0602Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8602 78.6602C31.5902 78.6702 32.1902 78.0902 32.2102 77.3502C32.2102 77.1302 32.1602 76.9202 32.0602 76.7202C31.3602 75.4502 30.0102 74.6602 28.5602 74.6602H27.8902C26.4402 74.6602 25.0902 75.4502 24.3902 76.7202C24.0602 77.3702 24.3202 78.1702 24.9702 78.5102C25.1602 78.6102 25.3802 78.6602 25.5902 78.6502H30.8602V78.6602Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 47.3997V35.0697C20.07 34.8397 20.01 34.6197 19.9 34.4197L17.55 30.1797C12.27 32.0897 8.76 37.0897 8.75 42.7097V45.7497C8.75 49.5897 11.86 52.6897 15.69 52.6897H21.23V47.3897H20.07V47.3997Z",
    fill: "#2B6BF3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0699 47.3996H16.8899C14.9699 47.3996 13.4199 45.8496 13.4199 43.9296V40.0596",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 47.3997V35.0697C20.07 34.8397 20.01 34.6197 19.9 34.4197L17.55 30.1797C12.27 32.0897 8.76 37.0897 8.75 42.7097V45.7497C8.75 49.5897 11.86 52.6897 15.69 52.6897H21.23V47.3897H20.07V47.3997Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3504 34.6197C16.5404 35.3297 17.2804 35.7497 17.9804 35.5497C18.0304 35.5397 18.0804 35.5197 18.1204 35.4997L20.0204 34.7397C19.9904 34.6297 19.9504 34.5197 19.8904 34.4197L17.5404 30.1797C16.8004 30.4497 16.0804 30.7797 15.4004 31.1697L16.3404 34.6097L16.3504 34.6197Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7904 34.6197C27.6004 35.3297 26.8704 35.7497 26.1604 35.5497C26.1104 35.5397 26.0604 35.5197 26.0104 35.4997L24.1104 34.7397C24.1404 34.6297 24.1804 34.5197 24.2404 34.4197L26.5904 30.1797C27.3304 30.4497 28.0504 30.7797 28.7304 31.1697L27.7904 34.6097V34.6197Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7303 52.7004C25.2603 52.7004 24.0703 51.5104 24.0703 50.0404V35.0804C24.0703 34.8504 24.1303 34.6304 24.2403 34.4304L26.5903 30.1904C31.8703 32.0904 35.3903 37.1004 35.3903 42.7204V45.0804C35.3903 46.3604 36.4203 47.4004 37.7003 47.4004H38.7003V52.7004H36.5103C33.3103 52.7004 30.7203 50.1104 30.7203 46.9104V52.7004H26.7303Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4603 20.2499C31.4603 19.4699 30.9003 18.7999 30.1303 18.6499V17.5899C30.2203 13.1799 26.7103 9.52993 22.3003 9.44993C17.8903 9.35993 14.2403 12.8699 14.1603 17.2799C14.1603 17.3799 14.1603 17.4899 14.1603 17.5899V18.6599C13.2803 18.8299 12.6903 19.6799 12.8603 20.5599C13.0003 21.2799 13.6003 21.8299 14.3303 21.8899C15.2303 26.2099 19.4603 28.9799 23.7803 28.0799C26.8903 27.4299 29.3203 24.9999 29.9703 21.8899C30.8103 21.8099 31.4603 21.1099 31.4703 20.2599L31.4603 20.2499Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1504 24.25C21.3604 25.06 22.9304 25.06 24.1404 24.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28.45 10.3298C28.34 10.2198 28.31 10.0598 28.37 9.90984C28.59 9.33984 28.73 8.74984 28.78 8.13984C28.8 7.91984 28.64 7.72984 28.41 7.70984C28.37 7.70984 28.34 7.70984 28.3 7.70984C26.62 7.92984 24.91 7.91984 23.24 7.66984C22.88 7.61984 22.51 7.59984 22.15 7.58984C17.37 7.58984 13.5 11.4598 13.5 16.2398V17.2098C13.5 17.8298 13.89 18.3698 14.48 18.5698C14.98 18.7298 15.52 18.4598 15.68 17.9698C15.69 17.9298 15.7 17.8998 15.71 17.8598C15.97 16.0598 16.98 14.4398 18.48 13.4198C18.63 13.3198 18.82 13.3298 18.96 13.4398C19.69 13.9898 20.58 14.2798 21.49 14.2598C21.95 14.2598 22.4 14.1898 22.84 14.0498C23 13.9998 23.17 14.0498 23.27 14.1798C23.95 15.0398 25.2 15.1798 26.05 14.4998C26.13 14.4398 26.2 14.3698 26.27 14.2998C26.42 14.1398 26.67 14.1298 26.83 14.2798C26.83 14.2798 26.84 14.2898 26.85 14.2998C27.79 15.2798 28.4 16.5298 28.61 17.8698C28.71 18.3798 29.21 18.7198 29.72 18.6098C29.76 18.6098 29.8 18.5898 29.84 18.5798C30.42 18.3798 30.82 17.8398 30.82 17.2198V16.2498C30.82 14.0398 29.98 11.9198 28.47 10.3198L28.45 10.3298Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8096 18.2598H23.4696",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8104 20.9198H17.1504C16.6004 20.9198 16.1504 20.4698 16.1504 19.9198V17.8898C16.1504 17.7198 16.2804 17.5898 16.4504 17.5898H20.5104C20.6804 17.5898 20.8104 17.7198 20.8104 17.8898V19.9198C20.8104 20.4698 20.3604 20.9198 19.8104 20.9198Z",
    fill: "#2B6BF3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8104 20.9198H17.1504C16.6004 20.9198 16.1504 20.4698 16.1504 19.9198V17.8898C16.1504 17.7198 16.2804 17.5898 16.4504 17.5898H20.5104C20.6804 17.5898 20.8104 17.7198 20.8104 17.8898V19.9198C20.8104 20.4698 20.3604 20.9198 19.8104 20.9198Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1297 20.9198H24.4697C23.9197 20.9198 23.4697 20.4698 23.4697 19.9198V17.8898C23.4697 17.7198 23.5997 17.5898 23.7697 17.5898H27.8297C27.9997 17.5898 28.1297 17.7198 28.1297 17.8898V19.9198C28.1297 20.4698 27.6797 20.9198 27.1297 20.9198Z",
    fill: "#2B6BF3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1297 20.9198H24.4697C23.9197 20.9198 23.4697 20.4698 23.4697 19.9198V17.8898C23.4697 17.7198 23.5997 17.5898 23.7697 17.5898H27.8297C27.9997 17.5898 28.1297 17.7198 28.1297 17.8898V19.9198C28.1297 20.4698 27.6797 20.9198 27.1297 20.9198Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.11 71.4003C41.11 70.2503 40.18 69.3203 39.03 69.3203H32.08C30.93 69.3203 30 70.2503 30 71.4103C30 72.5603 30.93 73.4903 32.08 73.4903H39.03C40.18 73.4903 41.11 72.5603 41.11 71.4103V71.4003Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7201 75.5605C39.7201 74.4105 38.7901 73.4805 37.6401 73.4805H30.7001C29.5501 73.4805 28.6201 74.4105 28.6201 75.5605C28.6201 76.7105 29.5501 77.6405 30.7001 77.6405H37.6401C38.7901 77.6405 39.7201 76.7105 39.7201 75.5605Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7201 79.7304C39.7201 78.5804 38.7901 77.6504 37.6401 77.6504H30.7001C29.5501 77.6504 28.6201 78.5804 28.6201 79.7404C28.6201 80.8904 29.5501 81.8204 30.7001 81.8204H37.6401C38.7901 81.8204 39.7201 80.8904 39.7201 79.7404V79.7304Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8297 79.7304C50.8297 78.5804 49.8997 77.6504 48.7497 77.6504H41.7997C40.6497 77.6504 39.7197 78.5804 39.7197 79.7404C39.7197 80.8904 40.6497 81.8204 41.7997 81.8204H48.7497C49.8997 81.8204 50.8297 80.8904 50.8297 79.7404V79.7304Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8301 75.5605C50.8301 74.4105 49.9001 73.4805 48.7501 73.4805H41.8001C40.6501 73.5105 39.7401 74.4605 39.7601 75.6105C39.7801 76.7305 40.6801 77.6205 41.8001 77.6505H48.7501C49.9001 77.6505 50.8301 76.7205 50.8301 75.5705V75.5605Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.11 71.4003C41.11 70.2503 40.18 69.3203 39.03 69.3203H32.08C30.93 69.3203 30 70.2503 30 71.4103C30 72.5603 30.93 73.4903 32.08 73.4903H39.03C40.18 73.4903 41.11 72.5603 41.11 71.4103V71.4003Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2799 67.2304C45.2799 66.0804 44.3499 65.1504 43.1999 65.1504H36.2499C35.0999 65.1504 34.1699 66.0804 34.1699 67.2304C34.1699 68.3804 35.0999 69.3104 36.2499 69.3104H43.1899C44.3399 69.3104 45.2699 68.3804 45.2699 67.2304H45.2799Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2799 67.2304C45.2799 66.0804 44.3499 65.1504 43.1999 65.1504H36.2499C35.0999 65.1504 34.1699 66.0804 34.1699 67.2304C34.1699 68.3804 35.0999 69.3104 36.2499 69.3104H43.1899C44.3399 69.3104 45.2699 68.3804 45.2699 67.2304H45.2799Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7201 75.5605C39.7201 74.4105 38.7901 73.4805 37.6401 73.4805H30.7001C29.5501 73.4805 28.6201 74.4105 28.6201 75.5605C28.6201 76.7105 29.5501 77.6405 30.7001 77.6405H37.6401C38.7901 77.6405 39.7201 76.7105 39.7201 75.5605Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7201 79.7304C39.7201 78.5804 38.7901 77.6504 37.6401 77.6504H30.7001C29.5501 77.6504 28.6201 78.5804 28.6201 79.7404C28.6201 80.8904 29.5501 81.8204 30.7001 81.8204H37.6401C38.7901 81.8204 39.7201 80.8904 39.7201 79.7404V79.7304Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8297 79.7304C50.8297 78.5804 49.8997 77.6504 48.7497 77.6504H41.7997C40.6497 77.6504 39.7197 78.5804 39.7197 79.7404C39.7197 80.8904 40.6497 81.8204 41.7997 81.8204H48.7497C49.8997 81.8204 50.8297 80.8904 50.8297 79.7404V79.7304Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8301 75.5605C50.8301 74.4105 49.9001 73.4805 48.7501 73.4805H41.8001C40.6501 73.5105 39.7401 74.4605 39.7601 75.6105C39.7801 76.7305 40.6801 77.6205 41.8001 77.6505H48.7501C49.9001 77.6505 50.8301 76.7205 50.8301 75.5705V75.5605Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2204 71.4003C52.2204 70.2503 51.2903 69.3203 50.1404 69.3203H43.1903C42.0403 69.3203 41.1104 70.2503 41.1104 71.4103C41.1104 72.5603 42.0403 73.4903 43.1903 73.4903H50.1404C51.2903 73.4903 52.2204 72.5603 52.2204 71.4103V71.4003Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2204 71.4003C52.2204 70.2503 51.2904 69.3203 50.1404 69.3203H43.1903C42.0403 69.3203 41.1104 70.2503 41.1104 71.4103C41.1104 72.5603 42.0403 73.4903 43.1903 73.4903H50.1404C51.2904 73.4903 52.2204 72.5603 52.2204 71.4103V71.4003Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 54.2196C40.3902 54.2196 45.5702 49.0296 45.5702 42.6396C45.5702 36.2496 40.3802 31.0596 33.9902 31.0596C27.6002 31.0596 22.4102 36.2496 22.4102 42.6396C22.4102 49.0296 27.6002 54.2196 33.9902 54.2196Z",
    fill: "#2B6BF3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 54.2196C40.3902 54.2196 45.5702 49.0296 45.5702 42.6396C45.5702 36.2496 40.3802 31.0596 33.9902 31.0596C27.6002 31.0596 22.4102 36.2496 22.4102 42.6396C22.4102 49.0296 27.6002 54.2196 33.9902 54.2196Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 54.2196C40.3902 54.2196 45.5702 49.0296 45.5702 42.6396C45.5702 36.2496 40.3802 31.0596 33.9902 31.0596C27.6002 31.0596 22.4102 36.2496 22.4102 42.6396C22.4102 49.0296 27.6002 54.2196 33.9902 54.2196Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9898 51.0402C38.6298 51.0402 42.3898 47.2802 42.3898 42.6402C42.3898 38.0002 38.6298 34.2402 33.9898 34.2402C29.3498 34.2402 25.5898 38.0002 25.5898 42.6402C25.5898 47.2802 29.3498 51.0402 33.9898 51.0402Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5999 40.0299C36.5999 38.5899 35.4299 37.4199 33.9899 37.4199H33.7999C32.4599 37.4199 31.3799 38.5099 31.3799 39.8399C31.3799 40.7599 31.8999 41.5999 32.7199 42.0099L35.2699 43.2799C36.4699 43.8799 36.9499 45.3299 36.3499 46.5299C35.9399 47.3499 35.0999 47.8699 34.1799 47.8699H33.9899C32.5499 47.8699 31.3799 46.6999 31.3799 45.2599",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 37.4096V36.0996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 49.1703V47.8604",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9603 50.22L43.5203 51.92C43.1403 52.38 42.4903 52.5 41.9703 52.21L40.9303 51.6C40.3603 51.25 40.1803 50.51 40.5303 49.94C40.5703 49.88 40.6103 49.82 40.6503 49.77L42.3603 47.75C42.7803 47.23 43.5403 47.15 44.0603 47.57C44.1203 47.61 44.1703 47.66 44.2103 47.72L44.9903 48.65C45.3603 49.11 45.3503 49.77 44.9603 50.22Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9002 52.5301C24.1902 52.5601 25.2502 51.5401 25.2802 50.2501C25.2802 50.2301 25.2802 50.2101 25.2802 50.2001C25.2802 48.9101 24.2402 47.8701 22.9502 47.8701C22.9302 47.8701 22.9102 47.8701 22.9002 47.8701H21.2402V52.5301H22.9002Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.302814a4fcf1365e995858b24bd1adb5.svg";
export { ForwardRef as ReactComponent };